(ns common.schema.entities.scheduled-job
  (:require
   [common.schema.schema-utils :as su]))

(def PRIORITY_LOW 0)
(def PRIORITY_MEDIUM 10)
(def PRIORITY_HIGH 100)
(def PRIORITY_URGENT 1000)
(def PRIORITY_CRITICAL 10000)

(def job-statuses
  {:scheduled-job.status/pending   "Pending"
   :scheduled-job.status/running   "Running"
   :scheduled-job.status/unknown   "Unknown"
   :scheduled-job.status/failed    "Failed"
   :scheduled-job.status/succeeded "Succeeded"
   :scheduled-job.status/stopped   "Stopped"})

(def job-status-options
  (->> job-statuses
       (mapv (fn [[k v]]
               {:key   k
                :label v}))))

(def schema
  (vec (concat (su/name-unique-global :scheduled-job/job-name
                                      "Job name"
                                      {:authorization    su/access-system-system
                                       :system-semantics su/system-controlled-optional-field-semantics})
               (su/keyword-field :scheduled-job/type
                                 "Job type"
                                 nil
                                 {:authorization    su/access-system-system
                                  :system-semantics su/system-controlled-optional-field-semantics})
               (su/boolean-field :scheduled-job/stop-failed-job?
                                 "Stop failed job?"
                                 {:authorization    su/access-system-system
                                  :system-semantics su/system-controlled-optional-field-semantics})
               (su/boolean-field :scheduled-job/stop-unknown-job?
                                 "Stop unknown job?"
                                 {:authorization    su/access-system-system
                                  :system-semantics su/system-controlled-optional-field-semantics})
               (su/text-simple-field :scheduled-job/cron
                                     "Cron config"
                                     {:authorization    su/access-system-system
                                      :system-semantics su/system-controlled-optional-field-semantics})
               (su/keyword-field :scheduled-job/status
                                 "Job status"
                                 job-status-options
                                 {:authorization    su/access-system-system
                                  :no-history?      true
                                  :system-semantics su/system-controlled-optional-field-semantics})
               (su/text-simple-multi-field :scheduled-job/executing-instance
                                           "Executing instances"
                                           {:authorization    su/access-system-system
                                            :system-semantics su/system-controlled-optional-field-semantics})
               (su/integer-field :scheduled-job/retry-counter
                                 "Retry counter"
                                 {:authorization    su/access-system-system
                                  :system-semantics su/system-controlled-optional-field-semantics})
               (su/integer-field :scheduled-job/max-retry-count
                                 "Max retries"
                                 {:authorization    su/access-system-system
                                  :system-semantics su/system-controlled-optional-field-semantics})
               (su/integer-field :scheduled-job/concurrency-count
                                 "Number of concurrently executing instances"
                                 {:authorization    su/access-system-system
                                  :system-semantics su/system-controlled-optional-field-semantics})
               (su/datetime-field :scheduled-job/last-scheduled-start
                                  "Last start time"
                                  {:authorization    su/access-system-system
                                   :no-history?      true
                                   :system-semantics su/system-controlled-optional-field-semantics})
               (su/datetime-field :scheduled-job/next-occurrence
                                  "Next scheduled start time"
                                  {:authorization    su/access-system-system
                                   :no-history?      true
                                   :system-semantics su/system-controlled-optional-field-semantics})
               (su/datetime-field :scheduled-job/last-status-update
                                  "Last status update"
                                  {:authorization    su/access-system-system
                                   :no-history?      true
                                   :system-semantics su/system-controlled-optional-field-semantics})
               (su/integer-field :scheduled-job/max-progress-interval-in-ms
                                 "Max progress interval in ms before considered failed"
                                 {:authorization    su/access-system-system
                                  :system-semantics su/system-controlled-optional-field-semantics})
               (su/percentage-field :scheduled-job/progress
                                    "Progress"
                                    {:authorization    su/access-system-system
                                     :no-history?      true
                                     :system-semantics su/system-controlled-optional-field-semantics})
               (su/integer-field :scheduled-job/priority
                                 "Priority"
                                 {:authorization    su/access-system-system
                                  :system-semantics su/system-controlled-optional-field-semantics}))))
